export default __webpack_public_path__ + "static/media/chatApplication.26dbb345.jpg";